


































































































import SvgIcon from '@/components/SvgIcon';
import Spinner from '@/components/Spinner';
import Button from '@/components/Controls/Button';
import { parallax } from './effects';
import Overlay from './Overlay.vue';
import { Component } from 'vue-property-decorator';
import { SwiperOptions } from './types';
import { BaseSlider } from './BaseSlider';
import { getQueryParamsMap, removeQueryParameter } from '@/utils/url';

@Component({
    components: {
        SvgIcon,
        Spinner,
        Button,
        Overlay,
        Swiper: () =>
            import(
                /* webpackChunkName: "Swiper" */
                /* webpackMode: "lazy" */ 'vue-awesome-swiper'
            ).then(({ Swiper }) => Swiper),

        SwiperSlide: () =>
            import(
                /* webpackChunkName: "Swiper" */
                /* webpackMode: "lazy" */ 'vue-awesome-swiper'
            ).then(({ SwiperSlide }) => SwiperSlide),
    },
})
export default class FullscreenSlider extends BaseSlider {
    /**
     *
     */
    public active: boolean = false;
    /**
     *
     */
    public activeIndexFromUrl: number | null = null;
    /**
     *
     */
    public async setActivity(value: boolean) {
        this.active = value;

        if (value) {
            await this.$nextTick();

            const swiperOptionsDefault: SwiperOptions = {
                lazy: {
                    loadPrevNext: true,
                },
                longSwipesRatio: 0.3,
                preloadImages: false,
                loop: false,
                speed: 500,
                grabCursor: true,
                spaceBetween: 20,
                keyboard: {
                    enabled: true,
                    onlyInViewport: false,
                },
                pagination: {
                    el: this.navigation,
                    clickable: true,
                    renderBullet: (_index: number, className: string) =>
                        `<button class="${className}"><span class="swiper-pagination-bullet__inner"/></button>`,
                },
            };

            if (this.parallax) {
                this.swiperOptions = {
                    ...swiperOptionsDefault,
                    ...parallax(),
                };
            } else {
                this.swiperOptions = swiperOptionsDefault;
            }
        } else {
            this.swiperOptions = null;
        }
    }

    public onReady() {
        if (
            typeof this.activeIndexFromUrl === 'number' ||
            typeof this.sliderActiveSlide === 'number'
        ) {
            this.slideTo(this.activeIndexFromUrl || this.sliderActiveSlide, 0);
        }

        this.slidesCount = this.swiper.swiperInstance!.slides?.length;
        this.activeIndex = this.swiper.swiperInstance!.realIndex;
    }

    public mounted() {
        const { galleryId, activeSlide } = getQueryParamsMap();

        if (galleryId) {
            if (galleryId == this.galleryId) {
                if (activeSlide) {
                    this.activeIndexFromUrl = Number(activeSlide);
                }

                this.setActivity(true);
            }
        }
    }

    public onClose() {
        removeQueryParameter('galleryId');
        removeQueryParameter('activeSlide');
        this.setActivity(false);
    }
}
